module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av223-0178c7b44786e04261d7edf1e2ab856b.jpg";